import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { GosafeRoute } from "../gosafe/routes";
import { AuthRoute } from "../auth/routes";
import { SecretaryRoute } from "../secretary/routes";
import { PatientRoute } from "../patient/routes";
import { DoctorRoute } from "../doctor/routes";
import { useAuthStore } from "../auth/hooks";
import { Loading } from "../auth/ui";
import { MagicLoginPage } from "../auth/pages";
import PwaInstallPrompt from "../components/PwaInstallPrompt";

export const AppRouter = () => {
  const { status, rol, checkAuthToken } = useAuthStore();

  useEffect(() => {
    checkAuthToken();
  }, [checkAuthToken]);

  if (status === "checking") {
    return <Loading />;
  }

  return (
    <>
      <PwaInstallPrompt />
      <Routes>
        <Route path="auth/magic-login" element={<MagicLoginPage />} />
        {status === "not-authenticated" && (
          <>
            <Route path="/*" element={<GosafeRoute />} />
            <Route path="auth/*" element={<AuthRoute />} />
            <Route path="patient/*" element={<PatientRoute />} />
          </>
        )}
        {status === "authenticated" && (
          <>
            {rol.name === "ADMIN" && (
              <Route path="/*" element={<SecretaryRoute />} />
            )}
            {rol.name === "DOCTOR" && (
              <Route path="/*" element={<DoctorRoute />} />
            )}
          </>
        )}
      </Routes>
    </>
  );
};
